import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatListModule} from "@angular/material/list";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatTooltipModule} from "@angular/material/tooltip";

import {TranslocoModule} from "@jsverse/transloco";

import {LorenDateModule} from "../../shared/pipes/loren-date/loren-date.module";
import {LorenTrimModule} from "../../shared/pipes/loren-trim/loren-trim.module";
import {LorenNotificationPanelRoutingModule} from "./loren-notification-panel-routing.module";
import {
    LorenNotificationsPanelComponent
} from "./components/loren-notifications-panel/loren-notifications-panel.component";
import {MatCardTitle} from "@angular/material/card";

@NgModule({
    declarations: [LorenNotificationsPanelComponent],
    imports: [
        LorenNotificationPanelRoutingModule,
        CommonModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        ScrollingModule,
        MatFormFieldModule,
        FormsModule,
        MatListModule,
        RouterModule,
        LorenDateModule,
        LorenTrimModule,
        MatInputModule,
        TranslocoModule,
        MatTooltipModule,
        MatCardTitle,
    ],
})
export class LorenNotificationPanelModule {
}
